import { CommentCheckOutlineIcon } from './CommentCheckOutlineIcon';

/**
 * author: Austin Andrews
 * id D9BBEE92-5775-4364-8ECD-89C0872BE79F
 * name comment-check-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-check-outline.svg
 * tags
 */
export const CommentTickOutlineIcon = CommentCheckOutlineIcon;
export default CommentTickOutlineIcon